const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  isIphoneX: state => state.user.isIphoneX,
  currentShop: state => state.appstore.currentShop,
  playMusic: state => state.user.playMusic,
  toHualuoMusic: state => state.user.toHualuoMusic,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js